import { useEffect } from 'react';
import axios from 'axios';
import { getFunnel, getAffiliateParams, cameFromVariant } from '../utils/tracking';
import { VARIANT_SITE } from '../utils/variant';
import Navbar from '../components/Navbar';
import Visualizer from '../components/Visualizer';
import Testimonials from '../components/Testimonials';
import FAQ from '../components/FAQ';


	const Pricing = () => {
		// The startviralgpt funnel sells on the visualizer's plan picker, so give
		// it the same offer here rather than the marketing pricing cards.
		const fromVariant = cameFromVariant();

		useEffect(() => {
			axios.post("https://api.viralgpt.com/pixel", {
				event: "ViewContent",
				funnel: getFunnel(),
				...getAffiliateParams()
			}, { withCredentials: true }).catch(() => {});

			// Separate funnel step from VisualizerView so the journey can show
			// people who reached the plans without scanning, side by side with
			// those who loaded the visualizer.
			axios.post("https://api.viralgpt.com/pixel", {
				event: "PlansView",
				funnel: getFunnel(),
				...getAffiliateParams()
			}, { withCredentials: true }).catch(() => {});
		}, []);

		return (
			<div>
			  {/* The picker opens on stripe-section--gradient, whose top is #f6f9fc.
			      Left white, the fixed bar's spacer showed as a band above it. */}
			  <Navbar logoHref={fromVariant ? VARIANT_SITE : '/'} spacerBg="#fff" />

			  {/* One offer for every visitor. This used to fork on traffic source —
			      startviralgpt sent people to the quantity picker, everyone else
			      got the marketing cards — so the two funnels priced and sold the
			      same packages through different screens. Both read
			      config/packages.js, so nothing about the offer changes; the main
			      site now takes the variant's path to checkout.

			      Keeps id="pricing" because Testimonials' CTA anchors to it, and
			      the picker is what that link should land on. Subscribers still
			      manage their plan from /dashboard/upgrade, which renders the
			      legacy subscription cards. */}
			  <div id="pricing" className="pricing-page-picker">
			    <Visualizer plansOnly={true} />
			  </div>

				<Testimonials compactTop />

				{/* The free follower boost sits below the results rather than above
				    the offer: the claim is the hook, and by this point the visitor
				    has seen the packages and what they did for other accounts. The
				    picker above is plansOnly, so it renders no claim UI of its own
				    and the two instances don't compete. */}
				<Visualizer />

				<FAQ/>
			</div>
	
		)}

export default Pricing;
